import { Injectable } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { Store } from "@ngrx/store";
import {
  DeleteAttachmentSuccessAction,
  Attachment,
  ServicesCommon,
  SetAttachmentsAction,
} from "common-lib";
import { PortalAppState } from "../store/reducer";
import { AttachmentPage } from "../pages/attachments/attachment/attachment.page";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import {AttachmentsListPage} from "../pages/attachments/attachments/attachments-list.page";


@Injectable({
  providedIn: 'root'
})
export class AttachmentsPortalService {

  constructor(
    protected store: Store<PortalAppState>,
    public dialog: MatDialog,
    private servicesCommon: ServicesCommon,
    private http: HttpClient,
  ) {
  }


  openAttachments(type, attachments, newAttachment: Attachment, id: number, dismissCallback: (result) => void = null) {
    const a = !!attachments ? Array.isArray(attachments) ? attachments : [attachments] : !!newAttachment ? [newAttachment] : null;
    const payload = {
      attachments: a,
      type: type as ('task' | 'marker' | 'item' | 'profit_loss' | 'animal' | 'lease' | 'supply'),
      id: id
    }
    this.store.dispatch(new SetAttachmentsAction(payload));

    const dialogRef = this.dialog.open(AttachmentPage, {
      panelClass: "form-dialog",
      height: '600px',
      width: '500px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (!!result) {
        console.log(result);
        if (!!dismissCallback) {
          dismissCallback(result);
        }
      }
    });
  }

  openAttachmentList(type, attachments, newAttachment: Attachment, id: number, dismissCallback: (result) => void = null) {
    const a = !!attachments ? Array.isArray(attachments) ? attachments : [attachments] : !!newAttachment ? [newAttachment] : null;

    const dialogRef = this.dialog.open(AttachmentsListPage, {
      panelClass: "form-dialog",
      height: '1200px',
      width: '1500px',
      autoFocus: false,
      data: {
        attachments: a,
        moduleEntityId: id
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (!!result) {
        console.log(result);
        if (!!dismissCallback) {
          dismissCallback(result);
        }
      }
    });
  }

  deleteAttachment(attachment) {
    this.http.delete(
      environment.backend + `/private/attachments/${attachment.id}`,
      {headers: this.servicesCommon.getAuthHeaders()}
    ).pipe(catchError(error => {
      console.error(error);
      return of(null);
    })).subscribe((response: { attachmentId: number, type: 'task' | 'marker' | 'item' | 'profit_loss' | 'animal' | 'lease' | 'supply', moduleEntityId: number }) => {
      if (!!response) {
        this.store.dispatch(new DeleteAttachmentSuccessAction(response));
      }
    });
  }

}
